module.exports = __webpack_public_path__ + "img/Companycultrue-people.9aa355a5.png";